import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { LetterOnBoard } from '@schoolbelle/api/letter-to-board';
import { GroupMember, GroupMemberService } from '@schoolbelle/api/group-member';
import { MailMergeItem } from '@schoolbelle/api/letter';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mailmerge-admin-viewer',
  templateUrl: './mailmerge-admin-viewer.component.html',
  styleUrls: ['./mailmerge-admin-viewer.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class MailmergeAdminViewerComponent implements OnInit {
  @Input() item:LetterOnBoard; 
  @Input() content:string|{[lang:string]:string};
  @Input() lang:string;
  @Input() query:string;
  mailmerged_members:GroupMember[] = [];
  mailmerge:MailMergeItem[] = [];
  currentMailmergeIndex = 0;
  get selectedMember () {
    return this.mailmerged_members[this.currentMailmergeIndex];
  }
  get selectedMailmergeItem () {
    return this.mailmerge[this.currentMailmergeIndex];
  }
  subscriptions = new Subscription();
  loading:boolean = false;
  constructor(
    private member:GroupMemberService,
    private cdRef:ChangeDetectorRef,
  ) { }


  ngOnInit() {
    this.mailmerge = this.item.mailmerge && this.item.mailmerge.filter(g=>g.group_id !== 0);
    if (this.mailmerge) {
      this.loading = true;
      this.subscriptions.add(
        this.member.checkIn(undefined, true, this.item.created_at).subscribe(()=>{
          
          this.mailmerged_members = this.mailmerge.map(mm=>{
            return this.member.search({
              member_types:['student', 'faculty'],
              group_id:mm.group_id,
              member_name:this.turnScopeToName(mm.scopes),
            })[0];
          })
          .filter(m=>m);
          this.loading = false;
          this.cdRef.detectChanges();
        }, ()=>{
          this.loading = false;
          this.cdRef.detectChanges();
        })
      )
    }
  }
  private turnScopeToName (scope:string) {
    if (typeof scope !== 'string') return scope;
    return scope.replace(/^(studentparent_|faculty_)(col_[\d]+)?(_of_)?row_(.+)$/, (matched, prefix, col_num, conj, URIComponentEncoded_member_name)=>{
      return decodeURIComponent(URIComponentEncoded_member_name);
    });  
  }
  ngOnDestroy () {
    this.subscriptions.unsubscribe();
  }

}
